import moment from "moment-timezone";

export function gymToday(timezone) {
  return moment.tz(timezone || "America/New_York").format("YYYY-MM-DD");
}

/** Local calendar Y-M-D of a Date, i.e. the day the guest actually clicked. */
export function ymd(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** `YYYY-MM-DD` → a local Date at midnight, for react-day-picker. */
export function dateFromYmd(value) {
  if (typeof value !== "string") return null;
  const m = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
}

export function formatSlotTime(iso, timezone) {
  return moment
    .utc(iso)
    .tz(timezone || "America/New_York")
    .format("h:mm A");
}

export function formatSlotRange(startIso, endIso, timezone) {
  const tz = timezone || "America/New_York";
  return `${formatSlotTime(startIso, tz)} – ${moment.utc(endIso).tz(tz).format("h:mm A")}`;
}

/** A bare calendar day (YYYY-MM-DD) as a long label — no instant, no zone. */
export function formatCalendarDay(dateStr) {
  const m = moment(dateStr, "YYYY-MM-DD", true);
  return m.isValid() ? m.format("dddd, MMMM D, YYYY") : "";
}

export function formatLongDate(iso, timezone) {
  return moment
    .utc(iso)
    .tz(timezone || "America/New_York")
    .format("dddd, MMMM D, YYYY");
}

/** Short zone abbreviation (PDT, EST…) so the guest can sanity-check the time. */
export function zoneLabel(iso, timezone) {
  return moment
    .utc(iso ?? undefined)
    .tz(timezone || "America/New_York")
    .format("z");
}

/** The last bookable day, from the gym's rolling horizon. */
export function horizonEnd(timezone, weeks) {
  return moment
    .tz(timezone || "America/New_York")
    .add(Number(weeks) || 4, "weeks")
    .endOf("day")
    .format("YYYY-MM-DD");
}
